import ExpiredToken from '@/components/ExpiredToken'
import Sidenav from '@/components/Sidenav'
import Header from '@/components/Header'
import ChangePasswordDialog from '@/components/ChangePasswordDialog'
import { useBaseStore } from '@/store'
import { Outlet } from 'react-router-dom'
import { ReactNode, useEffect, useState } from 'react'
import { cn } from '@/lib/utils'
import { restrictToHorizontalAxis } from '@dnd-kit/modifiers'
import { Store } from '@/store/type'
import {
    DndContext,
    KeyboardSensor,
    MouseSensor,
    TouchSensor,
    closestCenter,
    useSensor,
    useSensors,
} from '@dnd-kit/core'
import { useToast } from '@/components/ui/use-toast'
import { OfflineProvider } from '@/context/OfflineContext'
import { useCheckMobile } from '@/hooks/useCheckMobile'
import BottomActionBar from '@/components/BottonNavigator'
interface MainLayoutProps {
    children?: ReactNode
}

const stateSelector = (state: Store) => ({
    isSidenavOpen: state.appConfigSlice.state.isSidenavOpen,
    tokenExpired: state.authSlice.state.tokenExpired,
    accessDenied: state.authSlice.state.accessDenied, 
    resetAccessDenied: state.authSlice.actions.resetAccessDenied,
    isMobile: state.appConfigSlice.state.isMobile
})

const MainLayout = ({ children }: MainLayoutProps) => {
    const { isSidenavOpen, tokenExpired, accessDenied, resetAccessDenied, isMobile} = useBaseStore(stateSelector)
    const [style, setStyle] = useState('')
    useCheckMobile()
    const { toast } = useToast() 
    const sensors = useSensors(
        useSensor(MouseSensor, {}),
        useSensor(TouchSensor, {}),
        useSensor(KeyboardSensor, {})
    )

    useEffect(() => {
        if(accessDenied){
            toast({
                title: 'Acesso Negado',
                description: "Você não tem acesso a funcionalidade dessa página!",
                variant: 'destructive',
            })
 
            setTimeout(() => resetAccessDenied(), 10000);
        }
    },[accessDenied])

   useEffect(() => {
    if(isMobile) {
        setStyle('')
    } 
    if(!isMobile) {
        const currentStyle = isSidenavOpen
                            ? 'ml-sidenav-closed w-container-sidenav-closed sm:ml-sidenav sm:w-container-sidenav'
                            : 'ml-sidenav-closed w-container-sidenav-closed'
        setStyle(currentStyle)
    }
    console.log(style)
   }, [isMobile, isSidenavOpen])
   
    return (
        <DndContext
            collisionDetection={closestCenter}
            modifiers={[restrictToHorizontalAxis]}
            sensors={sensors}
        >
            <div className="w-full h-screen overflow-hidden bg-background">
                <div className='md:block hidden '>
                    <Sidenav />
                </div>
                <div
                    className={cn(
                        'h-full',
                        style
                    )}
                >
                    <Header />
                    {tokenExpired && <ExpiredToken />}
                    <div
                        className={'h-container-header w-full overflow-y-auto md:pb-0 pb-16'}
                    >
                        <OfflineProvider >
                            {children || <Outlet />}
                        </OfflineProvider>
                            
                    </div>
                </div>
                <BottomActionBar />
            </div>
            <ChangePasswordDialog />
        </DndContext>
    )
}

export default MainLayout
